import React, { useState, useEffect } from 'react';

export function TechpackTimer({ remainingTime }) {
	// State to hold the formatted remaining time
	const [formattedTime, setFormattedTime] = useState('');
	const [time, setTime] = useState(null);

	// Function to format seconds into hours, minutes, and seconds

	const formatTime = (timeInSeconds) => {
		if (time === null) {
			return '';
		}
		const hours = Math.floor(timeInSeconds / 3600);
		const minutes = Math.floor((timeInSeconds % 3600) / 60);
		const seconds = timeInSeconds % 60;
		return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
			seconds
		).padStart(2, '0')}`;
	};

	useEffect(() => {
		setTime(remainingTime);
	}, [remainingTime]);

	// Update the formatted time every second
	useEffect(() => {
		const timer = setInterval(() => {
			let currentTime = time - 1;
			setFormattedTime(formatTime(currentTime));
			setTime(currentTime);
		}, 1000);
		return () => clearInterval(timer);
	}, [remainingTime, time]);

	return (
		<p className="regular-14 d-flex align-items-center">
			<span>{formattedTime.length > 2 && 'Please download the tech-pack within'}</span>

			<span className="regular-20 weight-700 red ml-1">{formattedTime} hours</span>
		</p>
	);
}
